import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    updates: [],
    loading: true,
    show_charts_updates: false
  },
  actions: actions,
  mutations: mutations,
  getters: getters
}
